export default "__VITE_ASSET__DemY3Xig__"